import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Grid } from '@mui/material';
import { customModal_Container } from 'assets/jss/modal/custom-modal-style';
import { useEffect } from 'react';

export default function CustomModal(props) {
  const { children, openText, open, setOpen, handleClose } = props;
  const handleOpen = () => setOpen(true);

  // useEffect(() => {
  //   if (open) {
  //     document.body.style.overflow = 'hidden !important';
  //   } else {
  //     document.body.style.overflow = 'unset';
  //   }
  // }, [open]);

  return (
    <div>
      <span onClick={handleOpen}>{openText}</span>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        hideBackdrop
      >
        <>
          <Backdrop
            sx={{
              background: 'rgba(216, 216, 216, 0.3)',
              backdropFilter: 'blur(5.7957px)',
              transition: 'ease-in-out 0.2s !important'
            }}
            open={open}
            onClick={handleClose}
          />
          <Fade in={open}>
            <Grid container sx={customModal_Container}>
              <Grid container xs={12} item>
                {children}
              </Grid>
            </Grid>
          </Fade>
        </>
      </Modal>
    </div>
  );
}
